// Copyright (c) 2023 Practice Insight Pty Ltd. All rights reserved.

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file wisetime/type/site_preferences.proto (package wisetime.type, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file wisetime/type/site_preferences.proto.
 */
export const file_wisetime_type_site_preferences: GenFile = /*@__PURE__*/
  fileDesc("CiR3aXNldGltZS90eXBlL3NpdGVfcHJlZmVyZW5jZXMucHJvdG8SDXdpc2V0aW1lLnR5cGUqoQEKElJvdW5kaW5nUHJlZmVyZW5jZRIjCh9ST1VORElOR19QUkVGRVJFTkNFX1VOU1BFQ0lGSUVEEAASFQoRUEVSQ0VOVEFHRV9QT0lOVFMQARITCg9USFJFRV9NSU5fVU5JVFMQBRIRCg1TSVhfTUlOX1VOSVRTEAISFAoQVFdFTFZFX01JTl9VTklUUxAEEhEKDVFVQVJURVJfSE9VUlMQAyqUAQocRGlyZWN0VGltZWxpbmVQb3N0UHJlZmVyZW5jZRIvCitESVJFQ1RfVElNRUxJTkVfUE9TVF9QUkVGRVJFTkNFX1VOU1BFQ0lGSUVEEAASIAocRElSRUNUX1RJTUVMSU5FX1BPU1RfRU5BQkxFRBABEiEKHURJUkVDVF9USU1FTElORV9QT1NUX0RJU0FCTEVEEAJCLwoVY29tLndpc2V0aW1lLmFwaS50eXBlQhRTaXRlUHJlZmVyZW5jZXNQcm90b1ABYgZwcm90bzM");

/**
 * A team's rounding preference (in number of seconds) with regards to time group duration.
 * The following options are presented as levels of granularity that corresponds to a specific value.
 *
 * @generated from enum wisetime.type.RoundingPreference
 */
export enum RoundingPreference {
  /**
   * @generated from enum value: ROUNDING_PREFERENCE_UNSPECIFIED = 0;
   */
  ROUNDING_PREFERENCE_UNSPECIFIED = 0,

  /**
   * fine (0.01 hrs = 36 secs)
   *
   * @generated from enum value: PERCENTAGE_POINTS = 1;
   */
  PERCENTAGE_POINTS = 1,

  /**
   * short (0.05 hrs = 180 secs)
   *
   * @generated from enum value: THREE_MIN_UNITS = 5;
   */
  THREE_MIN_UNITS = 5,

  /**
   * medium (0.10 hrs = 360 secs)
   *
   * @generated from enum value: SIX_MIN_UNITS = 2;
   */
  SIX_MIN_UNITS = 2,

  /**
   * wider (0.20 hrs = 720 secs)
   *
   * @generated from enum value: TWELVE_MIN_UNITS = 4;
   */
  TWELVE_MIN_UNITS = 4,

  /**
   * broad (0.25 hrs = 900 secs)
   *
   * @generated from enum value: QUARTER_HOURS = 3;
   */
  QUARTER_HOURS = 3,
}

/**
 * Describes the enum wisetime.type.RoundingPreference.
 */
export const RoundingPreferenceSchema: GenEnum<RoundingPreference> = /*@__PURE__*/
  enumDesc(file_wisetime_type_site_preferences, 0);

/**
 * If enabled, allows posting time rows directly from the timeline (for a team) without a narrative.
 *
 * @generated from enum wisetime.type.DirectTimelinePostPreference
 */
export enum DirectTimelinePostPreference {
  /**
   * @generated from enum value: DIRECT_TIMELINE_POST_PREFERENCE_UNSPECIFIED = 0;
   */
  DIRECT_TIMELINE_POST_PREFERENCE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DIRECT_TIMELINE_POST_ENABLED = 1;
   */
  DIRECT_TIMELINE_POST_ENABLED = 1,

  /**
   * @generated from enum value: DIRECT_TIMELINE_POST_DISABLED = 2;
   */
  DIRECT_TIMELINE_POST_DISABLED = 2,
}

/**
 * Describes the enum wisetime.type.DirectTimelinePostPreference.
 */
export const DirectTimelinePostPreferenceSchema: GenEnum<DirectTimelinePostPreference> = /*@__PURE__*/
  enumDesc(file_wisetime_type_site_preferences, 1);

